import Vue from 'vue'
import commonHeader from '@/components/commonHeader.vue'
import commonBackHeader from '@/components/commonBackHeader.vue'
import commonBtn from '@/components/commonBtn.vue'
import privacyPage from '@/components/privacy.vue'
import empty from '@/components/empty.vue'
import menuBar from '@/components/menuBar.vue'
import commonField from '@/components/commonField.vue'
import commonLoading from '@/components/commonLoading.vue'
import commonFeedback from '@/components/commonFeedback.vue'
import commonPicker from '@/components/commonPicker.vue'
import commonSearchPicker from '@/components/commonSearchPicker.vue'
import commonTouchLoading from '@/components/commonTouchLoading.vue'
import commonDownloadGuide from '@/components/commonDownloadGuide.vue'

Vue.component('commonHeader', commonHeader)
Vue.component('commonBackHeader', commonBackHeader)
Vue.component('commonBtn', commonBtn)
Vue.component('privacyPage', privacyPage)
Vue.component('empty', empty)
Vue.component('menuBar', menuBar)
Vue.component('commonField', commonField)
Vue.component('commonLoading', commonLoading)
Vue.component('commonFeedback', commonFeedback)
Vue.component('commonPicker', commonPicker)
Vue.component('commonSearchPicker', commonSearchPicker)
Vue.component('commonTouchLoading', commonTouchLoading)
Vue.component('commonDownloadGuide', commonDownloadGuide)
